import React, { useState } from "react";
import { toast } from 'react-toastify';
import DatePicker from "react-datepicker";
import { Confirmar, Load } from "../partials/PopUps";
import {HojaReporte} from './TicketCorte';

export default function CorteVendedor({sesion}) {
	const messageError = 'Problemas de conexión intenten más tarde...';
	const [load,setLoad] = useState(false);
	const [fadeIn, setFadeIn] = useState(false);
	const [date, setDate] = useState(new Date());
	const [elcorte, setElcorte] = useState();
	const [open, setOpen]=useState(false);
  	const getDate = (date) => {
    	const f1 = new Date(new Date());
    	const f2 = new Date(date);
		
    	if (f2 > f1) {
      		toast.warning("No puede seleccionar una fecha después, al día de hoy");
    	}
    	return window.$parseDate(date);
  	};
	const generarReport = () => {
		const formatDate = getDate(date);
		setLoad(load=>!load);
		setFadeIn(!fadeIn)
		
		fetch(window.$api+'/cortedecaja/'+sesion.id+'_'+formatDate)
		  .then(res=>res.json())
		  .then(
		   response=>{
			setLoad(load=>!load);
			if( response.cantMayoreo > 0 || response.cantMenudeo > 0 ){
				setOpen(!open)
				setElcorte(response);
			}else{
				toast.warning('No se encontraron registros de venta para esta fecha')
			}
			
		   },
		   error=>toast.error(messageError)
		);
	}

  	return (
		<div className="xs-12 sm-5 md-5 lg-4 relative">
	
			<span>Fecha: &nbsp;</span>
			<DatePicker
				dateFormat="dd-MM-yyyy"
				selected={date}
				onChange={(date)=>{
					getDate(date)
					setDate(date)
				}}
				locale='es'
				className='input-normal'
			/>
			<div 
				className='btn btn-green btn-small btn-corte' 
				onClick={()=>setFadeIn(!fadeIn)}>
					Realizar corte
			</div>
				<Confirmar 
               		message={'¿Desea realizar el corte de caja?'}
               		fadeIn={fadeIn}
               		saveCaja={generarReport}
               		confirm={()=>setFadeIn(!fadeIn)}
            	/>
				<Load display={load} />
				
				{( elcorte?.cantMayoreo > 0 || elcorte?.cantMenudeo > 0)&&(
					<HojaReporte 
						data={elcorte}
						fecha={date}
						open={open}
						setOpen={setOpen}
					/>
				)}
		</div>
	)
	
}
